/**
 * Active palette (FS-11 slice). Per-sector colours come from `content/sectors.ts` (Design Bible
 * §9.3). Hue is never the only channel carrying information — hazards stay distinguishable by
 * silhouette and outline (Design Bible §12), which is what lets Event Horizon run near-monochrome
 * and Static Shore run desaturated without losing readability.
 */
import * as THREE from 'three';
import { SECTORS, type SectorPalette } from '../content/sectors';

export const PALETTE = {
  bg: new THREE.Color(0x05010f),
  primary: new THREE.Color(0x00e5ff),
  secondary: new THREE.Color(0xff2bd6),
  accent: new THREE.Color(0xff5da2),
  hull: new THREE.Color(0x8cf5ff),
  grid: new THREE.Color(0x3a2c7a),
  overdrive: new THREE.Color(0xffe45e),
  hazardHueShift: 0,
  desaturate: 0,
};

/** Swap the active palette. Called when a sector loads. */
export function applyPalette(p: SectorPalette): void {
  PALETTE.bg.setHex(p.bg);
  PALETTE.primary.setHex(p.primary);
  PALETTE.secondary.setHex(p.secondary);
  PALETTE.accent.setHex(p.accent);
  PALETTE.hull.setHex(p.hull);
  PALETTE.grid.setHex(p.grid);
  PALETTE.hazardHueShift = p.hazardHueShift;
  PALETTE.desaturate = p.desaturate;
}

applyPalette(SECTORS[0]!.palette);

/** Hazard colour for a kind's base hue, shifted and desaturated by the active sector palette. */
export function hueColor(h: number, sat = 0.9, light = 0.6): THREE.Color {
  const c = new THREE.Color();
  const hue = ((h + PALETTE.hazardHueShift) % 1 + 1) % 1;
  c.setHSL(hue, sat * (1 - PALETTE.desaturate), light + PALETTE.desaturate * 0.12);
  return c;
}
